export * from './FolderCertIcon';
export * from './FolderCertIcon16Light';
export * from './FolderCertIcon16Regular';
export * from './FolderCertIcon16Solid';
export * from './FolderCertIcon20Light';
export * from './FolderCertIcon20Regular';
export * from './FolderCertIcon20Solid';
export * from './FolderCertIcon24Regular';
export * from './FolderCertIcon24Solid';
export * from './FolderCertIcon32Regular';
export * from './FolderCertIcon64Regular';
